import { FileReader, FileWriter } from '@/platform'

class AvgButtonIndex {
    public Index: number = 0 //按钮索引
    public X: number = 0 //按钮X坐标
    public Y: number = 0 //按钮Y坐标

    constructor(index: number = 0, x: number = 0, y: number = 0) {
        this.Index = index
        this.X = x
        this.Y = y
    }

    readBin(reader: FileReader) {
        this.Index = reader.readInt()
        this.X = reader.readInt()
        this.Y = reader.readInt()
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.Index)
        writer.writeInt(this.X)
        writer.writeInt(this.Y)
    }

    readVersionedOui(reader: FileReader) {
        this.Index = reader.readInt()
        this.X = reader.readInt()
        this.Y = reader.readInt()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.Index)
        writer.writeInt(this.X)
        writer.writeInt(this.Y)

        writer.writerLength()
    }

    writeMallBin(writer: FileWriter): void {
        this.writeVersionedOui(writer)
    }
}

export default AvgButtonIndex
